/* OTUNBA — autoplay-on-scroll video, muted + looped, replaces deferred-media when in view */
(function () {
  function activate(dm) {
    if (dm.dataset.otunbaActivated) return;
    dm.dataset.otunbaActivated = "1";
    const tpl = dm.querySelector("template");
    if (!tpl) return;
    const content = tpl.content.cloneNode(true);
    const vid = content.querySelector("video");
    if (vid) {
      vid.autoplay = true;
      vid.muted = true;
      vid.loop = true;
      vid.playsInline = true;
      vid.removeAttribute("controls");
      vid.setAttribute("preload", "auto");
      vid.setAttribute("playsinline", "");
      vid.setAttribute("muted", "");
    }
    const iframe = content.querySelector("iframe");
    if (iframe && iframe.src) {
      try {
        const u = new URL(iframe.src);
        u.searchParams.set("autoplay", "1");
        u.searchParams.set("mute", "1");
        u.searchParams.set("loop", "1");
        u.searchParams.set("controls", "0");
        // YouTube needs `playlist=VIDEO_ID` to loop
        const m = u.pathname.match(/\/embed\/([^/?]+)/);
        if (m && u.host.includes("youtube")) u.searchParams.set("playlist", m[1]);
        iframe.src = u.toString();
        iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture");
      } catch (_) {}
    }
    dm.appendChild(content);
    // Hide the poster overlay
    const poster = dm.querySelector(".video-section__poster");
    if (poster) poster.style.display = "none";
    if (vid) vid.play().catch(() => {});
  }

  function init() {
    const sections = document.querySelectorAll('.shopify-section[id*="__video_"], .video-section');
    sections.forEach(section => {
      const dm = section.querySelector("deferred-media");
      if (!dm) return;
      if (!("IntersectionObserver" in window)) {
        activate(dm);
        return;
      }
      const obs = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) activate(dm); });
      }, { rootMargin: "200px 0px", threshold: 0.05 });
      obs.observe(section);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
